import React, { Component } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { TextField } from 'rmwc/TextField';

export class CustomInput extends React.Component {
  render() {
    return (
      <TextField
        name="date"
        placeholder={this.props.placeholder}
        label={this.props.label}
        value={this.props.value}
        onClick={this.props.onClick}
        readOnly
      />
    );
  }
}

export default class DatePickerControl extends Component {
  constructor(props) {
    super(props);

    this.state = { startDate: props.value || (props.setDefaultValue ? moment() : undefined) };
  }

  handleChange = date => {
    this.setState(
      {
        startDate: date,
      },
      () => this.props.onChange({ target: { name: this.props.name, value: date } })
    );
  };

  render() {
    return (
      <div>
        <DatePicker
          name={this.props.name}
          selected={this.state.startDate}
          customInput={<CustomInput label={this.props.label} />}
          onChange={this.handleChange}
          placeholderText={this.props.placeholder}
          showTimeSelect={this.props.showTimeSelect}
          dateFormat={this.props.dateFormat}
          showYearDropdown={this.props.showYearDropdown}
          dropdownMode={this.props.dropdownMode}
        />
      </div>
    );
  }
}

DatePickerControl.defaultProps = {
  showTimeSelect: true,
  dateFormat: 'LLL',
  showYearDropdown: false,
  setDefaultValue: true,
};
